/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CaptionRemove({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M11 14H2M2 10.938h12" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M11 7.875H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.625" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="m14.137 4.809-3.036-3.036M11.101 4.809l3.036-3.036" /></svg>;
}
;